import withUploadFile from './withUploadFile';
export default withUploadFile;
